import {convertFromISOFormat} from "../../utilis/timeUtilis";
import {TEAM_GROUPS, TeamGroup} from "./teamFilters";

export const groupLabel = (group: TeamGroup): string =>
    TEAM_GROUPS.find(entry => entry.key === group)?.label ?? '';

/** "3:30 PM", or "Oct 15, 2026, 3:30 PM" when not today; empty for past or missing dates. */
export const formatUntil = (isoDate: string | null | undefined): string => {
    const {dateString, timeString} = convertFromISOFormat(isoDate || '');
    return dateString ? `${dateString}, ${timeString}` : timeString;
};
